export function isSvgImageUrl(url) {
  if (typeof url !== 'string' || !url) return false;
  return /\.svg(?:$|[?#])/i.test(url);
}

export function isSvgImageFile(file) {
  if (!file) return false;
  const mime = String(file.mimeType || file.mime || file.type || '').toLowerCase();
  if (mime === 'image/svg+xml' || mime.includes('svg')) return true;
  const name = String(file.name || file.fileName || file.originalname || '');
  if (/\.svg$/i.test(name)) return true;
  const extension = String(file.extension || '').toLowerCase();
  if (extension === '.svg' || extension === 'svg') return true;
  return isSvgImageUrl(file.cdnPath || file.url || file.uri || '');
}

export function isSvgImageSource(fileOrUrl) {
  if (typeof fileOrUrl === 'string') return isSvgImageUrl(fileOrUrl);
  return isSvgImageFile(fileOrUrl);
}

export function getImagePreviewUrl(fileOrUrl) {
  if (!fileOrUrl) return null;
  if (typeof fileOrUrl === 'string') return fileOrUrl;
  if (isSvgImageFile(fileOrUrl) && fileOrUrl.thumbnailPath) {
    return fileOrUrl.thumbnailPath;
  }
  return fileOrUrl.cdnPath || fileOrUrl.url || fileOrUrl.uri || null;
}
